type SessionConfig = {
  optIn: boolean;
};

const defaults: SessionConfig = {
  optIn: true,
};

const callbacks: ((config: SessionConfig) => void)[] = [];

let config: SessionConfig | null = null;

/**
 * Register a callback to run when a session config is found on the window object.
 * @param callback - The callback to run if a session config is found on the window object.
 */
export function registerSessionConfigAction(
  callback: (config: SessionConfig) => void,
) {
  if (config) callback(config);
  else callbacks.push(callback);
}

const interval = setInterval(() => {
  //@ts-ignore
  const incomingConfig = window.sessionConfig as SessionConfig;
  if (incomingConfig) {
    config = { ...defaults, ...(incomingConfig ?? {}) };
    callbacks.forEach((callback) => callback(config!));
    clearInterval(interval);
  }
}, 200);
